var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendwhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_1830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.43087 12.5879C8.45301 12.6431 8.49149 12.6901 8.54116 12.7228C8.59082 12.7555 8.64929 12.7722 8.70872 12.7706C8.76814 12.7691 8.82568 12.7494 8.87361 12.7143C8.92154 12.6791 8.95756 12.6301 8.97684 12.5739L12.7643 1.50291C12.7829 1.45128 12.7865 1.39541 12.7745 1.34183C12.7626 1.28826 12.7356 1.23919 12.6968 1.20037C12.658 1.16156 12.6089 1.1346 12.5554 1.12265C12.5018 1.1107 12.4459 1.11426 12.3943 1.13291L1.3233 4.92035C1.26707 4.93964 1.21808 4.97566 1.18291 5.02359C1.14775 5.07151 1.12808 5.12905 1.12656 5.18848C1.12504 5.24791 1.14173 5.30637 1.1744 5.35604C1.20707 5.40571 1.25414 5.44419 1.30931 5.46633L5.92999 7.31926C6.07606 7.37774 6.20878 7.4652 6.32014 7.57636C6.4315 7.68751 6.51919 7.82007 6.57794 7.96604L8.43087 12.5879Z",
    stroke: "white",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6949 1.20264L6.32031 7.57661",
    stroke: "white",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_1830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9844,
    height: 13.9844,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendwhite);
export default __webpack_public_path__ + "static/media/sendwhite.e4814480ecac7ccff47e8658f27117c1.svg";
export { ForwardRef as ReactComponent };